<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <company-selector class="w-full" :company-name="companyName" v-model="companyId" @select="onChangeCompany" />
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
      <div>
        <company-selector class="w-full xl:w-48" v-model="companyId" @select="onChangeCompany" />
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchSelectCompany",
  components: {
    SearchFilterItem,
    CompanySelector,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "사업장명",
      type: String,
    },
    value: Object,
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'fId': '',
          'fName': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      const { companyId, companyName } = value;
      this.companyId = companyId;
      this.companyName = companyName;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : {companyId: '', companyName: ''};
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const companyId = query[_query_keys[0]];
      const companyName = query[_query_keys[1]];
      const data = {
        companyId: companyId || defaultValue.companyId,
        companyName: companyName || defaultValue.companyName,
      }
      return data;
    },
  },
  data() {
    return {
      companyId: "",
      companyName: "",
    };
  },
  created() {
    this.companyId = this.initData.companyId;
    this.companyName = this.initData.companyName;
    this.change({
      companyId: this.companyId,
      companyName: this.companyName,
    })
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onChangeCompany (company) {
      const data = {
        companyId: company.id,
        companyName: company.com_name,
      }
      this.change(data)
    },
    onClickFilterRemove () {
      console.log("remove")
      this.companyId = '';
      this.companyName = '';
      this.change({
        companyId: this.companyId,
        companyName: this.companyName,
      })
    }
  },
};
</script>
